import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Backdrop, CircularProgress, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  loadingText: {
    marginTop: theme.spacing(2),
    fontSize: '1.2rem',
    fontWeight: 500,
  },
}));

const LoadingOverlay = ({ open, message = "Cargando..." }) => {
  const classes = useStyles();

  return (
    <Backdrop className={classes.backdrop} open={open}>
      <CircularProgress color="inherit" size={60} />
      <Typography className={classes.loadingText}>
        {message}
      </Typography>
    </Backdrop>
  );
};

export default LoadingOverlay;
